<style lang="less">
.spec-popup {
  widows: 600px;
}

.home-view .shopping-cart {
  border: 0.5px solid #e3e2e2;
  border-radius: 3px;
}
@media only screen and (max-width: 600px) {
  .home-view .shopping-cart {
    display: none;
  }

  .home-view {
    position: static;
  }
}
.mobile-cart-show {
  .home-view {
    position: static;
  }

  .search-container {
    display: none;
  }
  .home-view .shopping-cart {
    position: absolute;
    display: block;
    left: 0;
    top: 60px;
    width: 100%;
    margin: 0;
    height: calc(100vh);
  }
}
.home-view {
  position: relative;
  height: calc(100vh - 90px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .yd-search-input {
    background-color: #fff;
    padding: 15px;
    input,
    .search-icon::after {
      font-size: 20px;
      color: #666;
    }
    input {
      text-indent: 10px;
    }
  }

  .shopping-cart {
    position: fixed;
    bottom: 0;
    //left: 50%;
    right: 3%;
    // margin-left: 189px;
    width: 360px;
    z-index: 100;
    font-size: 14px;
    .title {
      color: #333;
      background-color: #fafafa;
      height: 60px;
      line-height: 60px;
      padding: 0 10px;
      a {
        display: block;
      }
    }
    .cart-item-animation {
      div {
        position: relative;
        animation-duration: 300ms !important;
        z-index: 0;
      }
    }
    .cart-item {
      background-color: #fff;
      position: relative;
      z-index: 2;
      padding-bottom: 10px;
      margin-bottom: 10px;
      border-bottom: 1px solid #eee;
      padding-left: 15px;

      span.item-name {
        width: 75%;
      }
    }
    .yd-btn-block {
      margin-top: 0;
    }
    .yd-rollnotice-item {
      background-color: #fffdf0;
      padding: 0 10px;
    }
  }

  .goods-list {
    width: 660px;
    .yd-list-title,
    .yd-list-other {
      padding: 3px;
    }

    .yd-list-title span {
      line-break: anywhere;
    }

    .yd-list-title span i {
      background: #ff5a5a;
      border-radius: 2px;
      color: #eee;
      font-weight: bold;
      display: inline-block;
      padding: 1px 4px;
    }

    .yd-list-title span i.international {
      background: purple;
    }
    .yd-list-title span i.thirdparty {
      background: #00CC00;
    }
    
    @media only screen and (max-width: 600px) {
      .yd-list-theme2 .yd-list-item .yd-list-title {
        white-space: unset;
        /*overflow: unset;*/
        margin-bottom: 5px;
        height: 65px;
      }
    }

    @media only screen and (min-width: 800px) {
      .yd-list-theme2 .yd-list-item {
        padding-right: 1px;
        padding-left: 0;
      }

      .yd-list-theme2 .yd-list-item {
        width: 33%;
      }
      .yd-list-theme2 .yd-list-item .yd-list-title {
        white-space: unset;
        overflow: unset;
        margin-bottom: 20px;
      }

      .yd-list-theme2 .yd-list-item .yd-list-title {
        white-space: unset;
        /*overflow: unset;*/
        margin-bottom: 20px;
        height: 60px;
      }
    }

    @media only screen and (min-width: 1000px) {
      .yd-list-theme2 .yd-list-item {
        width: 20%;
      }
    }
    .list-discount {
      font-size: 12px;
      margin-left: 10px;
    }
    .icon-plus {
      color: #0bb20c;
    }
  }

  div.sort-bar {
    padding: 10px 5px;
    justify-content: space-around;

    div.selected {
      font-weight: bold;
      color: #ff5a5a;
    }
  }

  @media only screen and (min-width: 1000px) {
    .goods-list {
      width: 100%;
      padding-right: 25%;
    }
    div.sort-bar {
      padding-right: 25%;
    }
  }
}
.spec-selector {
  h3 {
    font-size: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
  }
  padding: 20px;
  .text-title {
    border-bottom: 1px solid #eee;
    font-size: 16px;
    padding-bottom: 10px;
  }
  .spec-block-line {
    margin-top: 20px;
    padding: 0 20px;
    font-size: 14px;
    .spec-block-title {
      min-width: 80px;
    }
    .flex-row {
      flex: 1;
      flex-wrap: wrap;
      .spec-block {
        display: block;
        border-radius: 12px;
        border: 1px solid #eee;
        padding: 5px 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .spec-block.selected {
        border-color: #ef4f4f;
      }

      .spec-block[disabled] {
        border-color: rgb(181, 181, 181);
        background: rgb(230, 230, 230);

        color: rgb(180, 180, 180);
        border-style: dashed;
      }
    }
  }
}
.spec-view-slider {
  margin-top: 20px;
  .swiper-container {
    width: 300px;
    height: 300px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
    .swiper-pagination {
      bottom: 0px;
      .swiper-pagination-bullet-active {
        background-color: red;
      }
    }
  }
}


input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}

</style>

<template>
  <div class="home-view wrap">
    <yd-search
      class="search-container"
      ref="search"
      v-model="keywords"
      placeholder="输入商品关键字搜索"
      cancel-text
    />
    <div class="flex-row sort-bar">
       <div  class="flex-col">
        <select style="-webkit-appearance:auto; border:none; color:black; width:90px;  text-align: center;" @change="switchBrandSelect($event)">
        <option value>全部品牌</option>
        <option value="ARMADA">ARMADA</option>
        <option value="K2">K2</option>
        <option value="LOOK">LOOK</option>
        <option value="TYROLIA">TYROLIA</option>
      </select>
      </div>
      <div
        class="flex-col"
      >
      </div>
    </div>
    <div class="flex-col flex-1 scroll-view" ref="sv">
      <div class="flex-row flex-sb">
        <div class="goods-list" v-if="goods.length > 0">
          <yd-infinitescroll :callback="loadList" ref="ifs">
            <yd-list theme="2" slot="list">
              <yd-list-item v-for="item in goods" :key="item.id">
                <img
                  slot="img"
                  v-lazy="
                    item.main_photo + '?x-oss-process=style/thumb-320x320'
                  "
                  v-on:click="setProduct(item)"
                />
                <span slot="title">
                  <i class="goods-type-tag">预售</i>{{ item.name }}
                </span>
                <yd-list-other slot="other">
                  <div class="flex-row flex-center">
                    <span class="price list-price">
                      <em>¥</em>
                      {{ item.sale_price }}
                    </span>
                    <span class="org-price list-price">
                      <em>¥</em>
                      {{ item.price }}
                    </span>
                    <span
                      class="price list-price list-discount"
                      v-if="item.discount"
                      >{{ item.discount }}折</span
                    >
                  </div>

                  <div class="icon-plus" v-on:click="setProduct(item)">
                    <v-icon scale="1.2" name="plus-circle" />
                  </div>
                </yd-list-other>
              </yd-list-item>
            </yd-list>
            <span slot="doneTip" style="margin: 10px 0">没有更多数据啦~~</span>
          </yd-infinitescroll>
          <yd-backtop right="1%" />
        </div>
        <div
          class="goods-list main-bg"
          style="height: calc(100vh - 200px)"
          v-if="goods.length == 0 && keywords != '' && !searching"
        >
          <div
            class="flex-col flex-all-center"
            style="height: 100%; color: #666"
          >
            <v-icon name="flushed" scale="6" />
            <span class="block" style="font-size: 14px"
              >没有找到匹配的商品，请换个关键字搜索~</span
            >
          </div>
        </div>
        <div class="shopping-cart main-bg">
          <yd-rollnotice :height="45" autoplay="3000">
            <yd-rollnotice-item
              class="notice-item"
              v-for="(text, index) in cartNotices"
              :key="index"
              >{{ text }}</yd-rollnotice-item
            >
          </yd-rollnotice>
          <div class="cart-list">
            <div class="title flex-row flex-sb">
              <span>购物车</span>
              <span>
                <a href="javascript:;" v-on:click="clearCart">清空</a>
              </span>
            </div>
            <div style="padding: 0 10px; font-size: 12px">
              <div
                style="padding: 20px"
                class="flex-col flex-center"
                v-if="cartItems.length == 0"
              >
                <span>购物车是空的</span>
              </div>
              <div
                style="padding: 15px 0; overflow: auto; max-height: 60vh"
                v-else
              >
                <transition-group
                  :name="animationCartItem"
                  tag="div"
                  class="cart-item-animation"
                >
                  <div v-for="key in Object.keys(cartItemsByOrg)" :key="key">
                    <h3>
                      <label>
                        <!-- <input
                          type="radio"
                          name="selectedCartOrg"
                          :value="key"
                          :checked="selectedOrgId == key ? true : false"
                          @click="selectedOrgId = key"
                        /> -->
                        {{
                          key > 0
                            ? cartItemsByOrg[key][0].orgType == 1
                              ? ""
                              : "海淘"
                            : "自营"
                        }}
                      </label>
                    </h3>

                    <div
                      class="flex-row flex-center flex-sb cart-item"
                      v-for="item in cartItemsByOrg[key]"
                      :key="item.id"
                    >
                      <span style="min-width: 180px" class="item-name">{{
                        item.name
                      }}</span>
                      <span class="price item-price" style="margin-left: 10px"
                        >￥{{ item.sale_price * 1 }}</span
                      >
                      <yd-spinner
                        :callback="cartNumberChange"
                        :val="item.id"
                        style="margin-left: 10px"
                        width="80px"
                        height="30px"
                        :longpress="false"
                        :min="0"
                        :max="item.stock"
                        :unit="1"
                        v-model="item.number"
                      />
                    </div>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
          <div class="flex-row flex-center flex-sb" style="padding: 0 10px">
            <span>
              已选 共
              <label class="price">{{ totalNumber }}</label> 件商品
            </span>
            <span>
              总计
              <label class="price" style="font-size: 16px"
                >￥{{ totalPrice }}</label
              >
            </span>
          </div>
          <div class="block" />
          <div class="flex-row bottom-bar">
            <yd-button
              size="large"
              shape="angle"
              bgcolor="#666"
              style="min-width: 60%"
              color="#fff"
            >
              <yd-icon size="32px" name="shopcart-outline" />
            </yd-button>
            <yd-button
              size="large"
              shape="angle"
              type="primary"
              @click.native="submit"
              >立即下单</yd-button
            >
          </div>
        </div>
      </div>
    </div>

    <yd-popup
      v-bind:width="popWindowWidth"
      close-on-masker
      v-model="showSpec"
      position="right"
    >
      <div v-if="spec" class="spec-selector main-bg">
        <h3>
          选择规格
          <a v-on:click="close()" style="float: right">X</a>
        </h3>
        <div class="spec-view-slider">
          <swiper :options="swiperOption">
            <swiper-slide v-for="item in specPhotos" :key="item">
              <img :src="item" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="flex-col">
          <div class="flex-col">
            <span class="text-title">选择颜色/尺码/数量</span>
            <div
              class="flex-row flex-center spec-block-line"
              v-if="product.colors.length > 0"
            >
              <span class="spec-block-title">颜色</span>
              <div class="flex-row">
                <span
                  v-on:click="setColor(color)"
                  :disabled="!stocks[`${color}|${specSize}`]"
                  class="spec-block"
                  v-for="(color, index) in product.colors"
                  :key="index"
                  v-bind:class="{ selected: specColor == color }"
                  >{{ color }}</span
                >
              </div>
            </div>
            <div
              class="flex-row flex-center spec-block-line"
              v-if="product.sizes.length > 0"
            >
              <span class="spec-block-title">尺码</span>
              <div class="flex-row">
                <span
                  v-on:click="setSize(size)"
                  :disabled="!stocks[`${specColor}|${size}`]"
                  class="spec-block"
                  v-for="(size, index) in product.sizes"
                  :key="index"
                  v-bind:class="{ selected: specSize == size }"
                  >{{ size }}</span
                >
              </div>
            </div>
            <div class="flex-row flex-center spec-block-line">
              <span class="spec-block-title">价格</span>
              <div class="flex-row">
                <span class="amount" style="margin-right: 10px"
                  >¥ {{ spec.sale_price }}</span
                >
                <span class="org-price yd-list-other" style="margin-right: 20px"
                  >¥ {{ parseFloat(spec.price).toFixed(2) }}</span
                >

                <yd-badge type="danger" v-if="spec.discount"
                  >{{ spec.discount }}折</yd-badge
                >
              </div>
            </div>
            <div class="flex-row flex-center spec-block-line">
              <span class="spec-block-title">库存</span>
              <div class="flex-row">
                <span :style="spec.stock==1?'color:red;':''">{{ spec.stock > 3 ? "库存充足" : (spec.stock > 1 ? "库存紧张": "最后一件")}}</span>
              </div>
            </div>
            <div class="flex-row flex-center spec-block-line">
              <span class="spec-block-title">数量</span>
              <yd-spinner
                width="100px"
                height="30px"
                :max="spec.stock"
                :unit="1"
                v-model="specNumber"
              />
            </div>
          </div>
        </div>
        <div class="buttons" style="margin-bottom: 10px">
          <yd-button size="large" type="primary" @click.native="addToCart"
            >加入购物车</yd-button
          >
        </div>
        <div>
          <img
            v-for="(imgsrc, index) in product.intro_photos"
            :key="index"
            style="display: block"
            slot="img"
            v-lazy="imgsrc"
            width="100%"
          />
        </div>
      </div>
    </yd-popup>
  </div>
</template>

<script>
import * as lodash from "lodash";

let searchTask;

export default {
  name: "home",
  data: () => ({
    page: 1,
    selectedOrgId: null,
    sort: "new",
    keywords: "",
    product: null,
    popWindowWidth: window.innerWidth < 600 ? "100%" : "600px",
    specNumber: 1,
    showSpec: false,
    specType: "color",
    specSize: "",
    specColor: "",
    animationCartItem: "slideUp",
    swiperOption: {
      lazy: {
        loadPrevNext: true,
      },
      pagination: {
        el: ".swiper-pagination",
      },
    },
  }),
  computed: {
    cartNotices() {
      return window.cartNotices;
    },
    cartItems() {
      return this.$store.state.cart.items;
    },
    orgIds() {
      var orgIds = this.$store.state.cart.items.map((o) => o.org_id);

      orgIds = _.uniq(orgIds);
      return orgIds;
    },
    selectedCartItems() {
      return this.$store.state.cart.items.filter((o) => {
        return o.org_id == this.selectedOrgId;
      });
    },

    cartItemsByOrg() {
      return lodash.groupBy(this.$store.state.cart.items, "org_id");
    },
    cartGroupItems() {
      return this.$store.state.cart.items;
    },
    totalNumber() {
      return lodash.sumBy(this.selectedCartItems, (item) => item.number);
    },
    totalPrice() {
      return lodash
        .sumBy(this.selectedCartItems, (item) => item.sale_price * item.number)
        .toFixed(2);
    },
    goods() {
      return this.$store.state.goods.goods.map((g) => {
        return g;
      });
    },
    searching() {
      return this.$store.state.goods.searching;
    },
    spec() {
      if (!this.product) {
        return null;
      }
      let spec = this.product.specs.filter(
        (spec) => spec.color == this.specColor && spec.size == this.specSize
      )[0];
      if (!spec) {
        const filter =
          this.specType == "color"
            ? (spec) => spec.color == this.specColor
            : (spec) => spec.size == this.specSize;
        spec = this.product.specs.filter(filter)[0];
        this.specColor = spec.color;
        this.specSize = spec.size;
      }
      return spec;
    },
    photos() {
      if (this.product === null) {
        return [];
      }
      if (this.__photos) {
        return this.__photos;
      }
      const photos = [this.product.main_photo].concat(
        lodash.flatten(
          this.product.specs.map((spec) => {
            if (spec.stock > 0) {
              return spec.photos;
            }
            return [];
          })
        )
      );
      this.__photos = lodash.uniq(photos);
      return this.__photos;
    },
    specPhotos() {
      const spec = this.spec;
      if (!spec) {
        return [];
      }
      return lodash.uniq(spec.photos);
    },
    specName() {
      if (!this.spec) {
        return "";
      }
      return [this.spec.color, this.spec.size, this.specNumber]
        .filter((v) => v && v != "")
        .join(" / ");
    },
  },

  watch: {
    async keywords(value) {
      await this.$store.dispatch("goods/resetGoods", value);
      if (this.searchTask) {
        this.searchTask.cancel();
      }
      this.page = 1;
      this.$refs.sv.scrollTop = 0;
      this.searchTask = lodash.debounce(
        async () => this.loadProducts(value, this.page),
        500
      );
      this.searchTask();
    },
  },
  methods: {
    switchSelect(event) {
      //debugger
      this.sort = event.target.value;
      this.updateSort();
      // this.selected = event.target.value;
    },
    switchBrandSelect(event) {
      this.brand = event.target.value;
      this.updateSort();
    },
    clearCart() {
      this.$dialog.confirm({
        title: "提示",
        mes: "确认要清空购物车吗？",
        opts: () => {
          this.animationCartItem = "slideDown";
          this.$store.dispatch("cart/clear");
        },
      });
    },
    setProduct(product) {
      this.product = product;
      const spec = product.specs[0];

      this.stocks = {};
      this.product.specs.forEach((o) => {
        this.stocks[`${o.color}|${o.size}`] = o.stock;
      });

      this.specSize = spec.size;
      this.specColor = spec.color;
      this.showSpec = true;
      this.specNumber = 1
    },
    setSize(size) {
      this.specType = "size";
      this.specSize = size;

      if (this.specNumber > this.spec.stock) {
        this.specNumber = 1;
        this.$store.dispatch("cart/add", { spec: this.spec, number: 1 });
      }
    },
    close() {
      this.showSpec = false;
    },
    setColor(color) {
      this.specType = "color";
      this.specColor = color;

      if (this.specNumber > this.spec.stock) {
        this.specNumber = 1;
        this.$store.dispatch("cart/add", { spec: this.spec, number: 1 });
      }
    },
    addToCart() {
      if (this.spec) {
        this.animationCartItem = "slideUp";

        if (this.cartItems.length == 0) {
          this.selectedOrgId = this.spec.org_id;
        }
        this.$store.dispatch("cart/add", {
          spec: this.spec,
          orgType: this.product.org_type,
          number: this.specNumber,
        });
      }
      this.showSpec = false;
    },
    cartNumberChange(itemId, number) {
      const item = lodash.find(this.cartItems, { id: itemId });
      if (item.number == 0) {
        this.$dialog.confirm({
          mes: "确认要将此商品从购物车移除吗？",
          opts: [
            {
              txt: "取消",
              color: false,
              callback: () => {
                item.number = Math.max(1, number);
                this.$store.dispatch("cart/updateNumber", {
                  id: item.id,
                  number: item.number,
                });
              },
            },
            {
              txt: "确定",
              color: true,
              callback: () => {
                this.animationCartItem = "slideDown";
                this.$store.dispatch("cart/remove", { id: item.id });

                if (this.selectedOrgId == item.org_id) {
                  this.selectedOrgId = null;

                  if (this.orgIds.length > 0) {
                    this.selectedOrgId = this.orgIds[0];
                  }
                }
              },
            },
          ],
        });
        return;
      }
      item.number = Math.max(1, number);
      this.$store.dispatch("cart/updateNumber", {
        id: item.id,
        number: item.number,
      });
      return item.number;
    },
    async loadProducts(keywords = "", page = 1) {
      try {
        this.$dialog.loading.open("");
        this.keywords = keywords;
        await this.$store.dispatch("goods/searchGoods", {
          keywords,
          page,
          sort: this.sort,
          brand: this.brand
        });
      } catch (e) {
        this.$errorHandle(e);
      } finally {
        this.$dialog.loading.close();
      }
    },

    async updateSort() {
      this.page = 1;
      //this.goods = [];
      //const length = this.goods.length;
      await this.loadProducts(this.keywords, this.page);
      this.$refs.ifs.$emit("ydui.infinitescroll.finishLoad");
      //this.$refs.ifs.$emit("ydui.infinitescroll.finishLoad");
    },
    async loadList() {
      this.page++;
      const length = this.goods.length;
      await this.loadProducts(this.keywords, this.page);
      if (length == this.goods.length) {
        this.$refs.ifs.$emit("ydui.infinitescroll.loadedDone");
      } else {
        this.$refs.ifs.$emit("ydui.infinitescroll.finishLoad");
      }
    },
    submit() {
      if (this.selectedOrgId == null) {
        this.$dialog.toast({ mes: "请选择一个商户结算" });
        return;
      }
      if (this.cartItems.length == 0) {
        this.$dialog.toast({ mes: "请至少加入一件商品到购物车" });
        return;
      }

      var orgIds = Object.keys(this.cartItemsByOrg);

      if (orgIds.length == 1) {
        this.$router.push({ name: "flow" });
        return;
      }
      if (!this.selectedOrgId && orgIds.length > 1) {
        this.$dialog.toast({ mes: "请选择店铺" });
        return;
      }
      this.$router.push({ name: "flow", query: { org: this.selectedOrgId } });
    },
  },
  async mounted() {
    await this.loadProducts();
    if (this.cartItems.length > 0 && !this.selectedOrgId) {
      this.selectedOrgId = this.orgIds[0];
    }
    const { input } = this.$refs.search.$refs.search.$refs;
    input && input.focus();
  },
};
</script>
